import {
  type ConditionTypeName,
  conditionTypeOperatorGroup,
  type InternalOperator,
  operatorGroups,
} from '@payaca/types/automationSchema';
import type {
  AutomationConditionOperator,
  AutomationConditionType,
} from './types.generated';

// Compile-time check: ConditionTypeName (from the shared schemas) must match
// AutomationConditionType (from the GQL codegen). If either adds/removes a
// type without the other being updated, one of these will fail to compile.
type _CheckAllGqlTypesCovered = [
  AutomationConditionType,
] extends [ConditionTypeName]
  ? true
  : 'ERROR: AutomationConditionType has types missing from conditionTypeOperatorGroup';
type _CheckNoExtraTypes = [ConditionTypeName] extends [AutomationConditionType]
  ? true
  : 'ERROR: conditionTypeOperatorGroup has types not in AutomationConditionType';
export type _AssertTypesInSync = _CheckAllGqlTypesCovered & _CheckNoExtraTypes;

const internalToGql: Record<InternalOperator, AutomationConditionOperator> = {
  includes: 'INCLUDES',
  equals: 'EQUALS',
  'not-equals': 'NOT_EQUALS',
};

/**
 * Valid GQL operators for each condition type, derived from the shared
 * condition schemas in @payaca/types.
 */
// Cast required: Object.fromEntries always returns Record<string, V>.
// The _AssertTypesInSync check above guarantees key completeness.
export const conditionTypeOperators = Object.fromEntries(
  Object.entries(conditionTypeOperatorGroup).map(([type, group]) => [
    type,
    operatorGroups[group].map((op) => internalToGql[op]),
  ])
) as Record<AutomationConditionType, AutomationConditionOperator[]>;
